/**
 * monthGrid — la grille d'un mois, en dates `YYYY-MM-DD`, la semaine commençant le lundi.
 *
 * Pure : `<MonthCalendar>` la lit, son test la vérifie. Les jours hors du mois sont `null` (la case
 * reste vide), la grille compte toujours des semaines entières. Le calcul des dates passe par moment,
 * comme le reste de l'app.
 */
import moment from "moment"

const MONTH = "YYYY-MM"

/** `YYYY-MM` d'une date `YYYY-MM-DD` (ou déjà d'un mois). */
export const monthOf = (date: string): string => date.slice(0, 7)

/** Le mois d'à côté, `offset` mois plus loin (négatif : plus tôt). */
export const shiftMonth = (month: string, offset: number): string =>
    moment(month, MONTH).add(offset, "month").format(MONTH)

/** Les semaines du mois : sept cases chacune, `null` hors du mois. */
export function monthWeeks(month: string): (string | null)[][] {
    const first = moment(month, MONTH)
    const cells: (string | null)[] = Array.from({ length: first.isoWeekday() - 1 }, () => null)
    for (let day = 0; day < first.daysInMonth(); day++) cells.push(first.clone().add(day, "day").format("YYYY-MM-DD"))
    while (cells.length % 7 !== 0) cells.push(null)
    const weeks: (string | null)[][] = []
    for (let i = 0; i < cells.length; i += 7) weeks.push(cells.slice(i, i + 7))
    return weeks
}

/** Le jour se choisit : dans les bornes, bornes comprises. Les dates `YYYY-MM-DD` se comparent en texte. */
export function inRange(day: string, min: string | null, max: string | null): boolean {
    return (min == null || day >= min) && (max == null || day <= max)
}
